/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import $ from 'jquery';
import 'foundation-sites';
import 'slick-carousel';
// import 'simple-lightbox';

// If you only need specific modules:
// import { Foundation, Accordion, Tabs } from 'foundation-sites';
(function($) {

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        
        $(document).foundation(); // Foundation JavaScript


        $('.hero-slider--slides').slick({
            dots: false,
            infinite: true,
            speed: 500,
            fade: false,
            cssEase: 'ease-in-out',
            autoplay: true,
            autoplaySpeed: 4000,
            arrows: true,
            prevArrow: document.querySelector('.hero-slider--prev'),
            nextArrow: document.querySelector('.hero-slider--next'),
           
        });

          document.getElementById('add-vehicle-submit').addEventListener('click', function() {
              // Get the values from the form fields
              const vehicle = {
                year: document.querySelector('#add-vehicle-modal .ymm-year').value,
                make: document.querySelector('#add-vehicle-modal .ymm-make').value,
                model: document.querySelector('#add-vehicle-modal .ymm-model').value,
                drivetrain: document.querySelector('#add-vehicle-modal .ymm-drivetrain').value
              };
            
              // Validate that all fields have values
              if (!vehicle.year || !vehicle.make || !vehicle.model || !vehicle.drivetrain) {
                alert('Please fill in all vehicle fields');
                return;
              }
            
              // Get existing vehicles from cookie or initialize empty array
              let vehicles = getVehiclesFromCookie();
            
              // Check for duplicates
              const isDuplicate = vehicles.some(v => 
                v.year === vehicle.year &&
                v.make === vehicle.make &&
                v.model === vehicle.model &&
                v.drivetrain === vehicle.drivetrain
              );
            
              if (isDuplicate) {
                alert('This vehicle has already been added');
                return;
              }
            
              // Add the new vehicle
              vehicles.push(vehicle);
            
              // Save to cookie (expires in 365 days)
              setVehiclesCookie(vehicles, 365);
            
              console.log('Vehicle added:', vehicle);
              console.log('All vehicles:', vehicles);
          });

        
          
          // Helper function to get vehicles from cookie
          function getVehiclesFromCookie() {
            const cookieValue = document.cookie
              .split('; ')
              .find(row => row.startsWith('userVehicles='));
            
            if (cookieValue) {
              try {
                return JSON.parse(decodeURIComponent(cookieValue.split('=')[1]));
              } catch (e) {
                return [];
              }
            }
            return [];
          }
          
          // Helper function to set vehicles cookie
          function setVehiclesCookie(vehicles, days) {
            const expires = new Date();
            expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
            
            const cookieValue = encodeURIComponent(JSON.stringify(vehicles));
            document.cookie = `userVehicles=${cookieValue};expires=${expires.toUTCString()};path=/`;
          }
          
          // Optional: Helper function to remove a vehicle
          function removeVehicle(index) {
            let vehicles = getVehiclesFromCookie();
            if (index >= 0 && index < vehicles.length) {
              vehicles.splice(index, 1);
              setVehiclesCookie(vehicles, 365);
            }

            // check if there are no vehicles left
            if( vehicles.length === 0 ){
              let empty_message = document.querySelector( "#garage-dropdown .empty-message"); 
                  empty_message.style.display = 'block';
            }


            return vehicles;
          }
          
          // Optional: Helper function to clear all vehicles
          function clearAllVehicles() {
            document.cookie = 'userVehicles=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/';
          }
          
          function populateGarageFromCookie(){
            let vehicles = getVehiclesFromCookie();
            console.log('Current vehicles:', vehicles);

            if( vehicles.length === 0 ){

              let empty_message = document.querySelector( "#garage-dropdown .empty-message"); 
                  empty_message.style.display = 'block';
              return;

            }

            // vehicle-list
            const vehicleList = document.querySelector('#garage-dropdown .vehicle-list');

            vehicles.forEach((vehicle, index) => {
              const listItem = document.createElement('div');
                    listItem.classList.add('saved-vehicle');

                    // add <a> inside of saved-vehicle
                    const link = document.createElement('a');
                    link.href = '/shop/?ymm_year=' + vehicle.year + '&ymm_make=' + vehicle.make + '&ymm_model=' + vehicle.model + '&ymm_drivetrain=' + vehicle.drivetrain;
                    link.textContent = `${vehicle.year} ${vehicle.make} ${vehicle.model} (${vehicle.drivetrain})`;
                    listItem.appendChild(link);

                    // add <button name="delete">×</button> inside of saved-vehicle
                    const deleteButton = document.createElement('button');
                    deleteButton.name = 'delete';
                    deleteButton.textContent = '×';
                    deleteButton.addEventListener('click', function(e) {
                      e.preventDefault();
                      removeVehicle(index);
                      listItem.remove();
                    });
                    listItem.appendChild(deleteButton);

              //listItem.textContent = `${vehicle.year} ${vehicle.make} ${vehicle.model} (${vehicle.drivetrain})`;
              vehicleList.appendChild(listItem);
            });


          }


          function populateYourVehicleFromParameters(){
            const urlParams = new URLSearchParams(window.location.search);
            const year = urlParams.get('ymm_year');
            const make = urlParams.get('ymm_make');
            const model = urlParams.get('ymm_model');
            const drivetrain = urlParams.get('ymm_drivetrain');

            console.log(urlParams);

            if( year && make && model && drivetrain ){
              const yourVehicleDiv = document.getElementById('your-vehicle-sidebar--text');
              yourVehicleDiv.textContent = `Showing parts for:  ${year} ${make} ${model} (${drivetrain})`;

            }

          }

          populateGarageFromCookie();

          populateYourVehicleFromParameters();


      
      },
      finalize: function() {

      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // All Other Pages.
    'page': {
      init: function() {
        
        // Accordion
        $('.accordion-topic').click(function(){
          $(this).next('.accordion-response').slideToggle(500).toggleClass('current');
          $(this).toggleClass('current');
          $(this).parents('.accordion').siblings().find('.accordion-topic').slideUp(500);
          $(this).parents('.accordion').siblings().find('.accordion-response').removeClass('current');
        });


      }
    },
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.